import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    photos: [],
    contactInfo: []
  },
  mutations: {
    SAVE_PHOTOS (state, results) {
      state.photos = results;
    },
    SAVE_CONTACT_INFO (state, results) {
      state.contactInfo = results;
    }
  },
  getters: {
    randomPhoto: state => {
      var randomIndex = Math.floor(Math.random() * state.photos.length);

      return { photo: state.photos[randomIndex], index: randomIndex };
    },
    hasPhotos: state => {
      return (state.photos.length > 0);
    }
  },
  actions: {
    async fetchPhotos (context, { vm , cb}) {
      if (this.state.photos.length == 0) {
        await vm.$prismic.client.query(
          vm.$prismic.Predicates.at('document.type', 'photography_item'), { pageSize : 100, orderings : '[order desc]' }
        ).then((response) => {
          // response is the response object, response.results holds the documents
          context.commit('SAVE_PHOTOS', response.results);

          cb(response.results);
        })
      }
      else {
        cb(this.state.photos);
      }
    },
    async fetchContactInfo (context, { vm , cb}) {
      if (this.state.photos.length == 0) {
        await vm.$prismic.client.query(
          vm.$prismic.Predicates.at('document.type', 'contact_page'), { pageSize : 100, orderings : '[document.first_publication_date]' }
        ).then((response) => {
          // response is the response object, response.results holds the documents
          context.commit('SAVE_CONTACT_INFO', response.results);

          cb(response.results);
        })
      }
      else {
        cb(this.state.photos);
      }
    },
    savePhotos (context, photos) {
      return new Promise((resolve) => {
        context.commit('SAVE_PHOTOS', photos);
        resolve();
      });
    }
  }
})
